import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(email, password, primeiroAcesso = false) {
    return axios.post(`${Constants.baseUrl}/auth`, { email, password, primeiroAcesso });
}

export function forgotPassword(form) {
    return axios.post(`${Constants.baseUrl}/forgot-password`, form);
}

export function resetPassword(form) {
    return axios.post(`${Constants.baseUrl}/reset-password`, form);
}

export function validarCodigo(form) {
    return axios.post(`${Constants.baseUrl}/forgot-password-code`, form);
}
